import { Avatar, Box } from "@mui/material";
import React from "react";
import usePrimaryColor from "../../../hooks/usePrimaryColor";
import useUser from "../../../hooks/useUser";
export default function ProfilePicture({
  size,
  jsContent = "center",
  avatarSize = 75,
  align = "center",
  flexDir = "row",
}) {
  const { profile } = useUser();
  return (
    <Box
      alignItems={align}
      display={"flex"}
      flexDirection={flexDir}
      justifyContent={jsContent}
    >
      <Avatar
        sx={{
          width: avatarSize,
          height: avatarSize,
          bgcolor: usePrimaryColor(),
          color: "whitesmoke",
          fontSize: avatarSize / 3,
        }}
      >
        {String(profile.initials)}
      </Avatar>
    </Box>
  );
}
